<template lang="pug">
.access.mobile-scroll.bta
  .button-area
    template(v-if="!isLoggedIn")
      a.btn-login(href='javascript:void(0)' @click="openLogModal()") {{$t('ui.login')}}
      a.btn-register(href='javascript:void(0)' @click="openRegisterModal()") {{$t('ui.register')}}
    template(v-else)
      router-link.btn-register.show-mobile(to='deposit') {{$t('ui.deposit')}} 
        i.fa-solid.fa-coins
      router-link.btn-login.show-mobile(to="withdrawal") {{$t('ui.withdrawal')}}  
          i.fa-solid.fa-circle-dollar-to-slot
</template>
<script>
export default{
  data(){
    return{
      // showMobile: false
    }
    
  },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
  },
  methods:{
    openLogModal(){
      $("#logModal").modal("show")
    },
    openRegisterModal(){
      $("#regModal").modal("show")
    },
  }
}
</script>
<style lang="scss" scoped>
.show-mobile{
  display: none !important;
  @media(max-width: 680px){
    display: inline-block !important;
  }
}
</style>